export const HighFiveImage = () => {
  return (
    <svg
      width="159"
      height="145"
      viewBox="0 0 159 145"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_597_42317)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M138.325 95.8569C139.489 100.1 140.168 104.586 143.199 105.439C149.241 107.141 144.277 112.006 149.347 113.8C156.623 116.375 153.942 124.632 152.483 127.338C148.977 133.841 143.131 133.095 143.131 133.095C143.131 133.095 132.572 134.861 113.648 128.993C111.944 129.08 101.133 119.806 112.641 109.443C115.28 107.066 115.729 102.553 116.678 100.821C121.029 92.885 137.163 98.1952 138.325 95.8569Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M138.652 95.7656C138.616 95.6335 138.502 95.5375 138.365 95.5243C138.229 95.511 138.099 95.5833 138.038 95.706C137.953 95.8777 137.738 95.9638 137.447 96.0362C136.92 96.1677 136.166 96.1929 135.256 96.1745C131.888 96.1069 126.466 95.4194 122.151 96.5636C119.707 97.2118 117.614 98.4428 116.399 100.659C115.788 101.772 115.38 104.027 114.475 106.134C113.985 107.273 113.346 108.369 112.429 109.194C108.271 112.939 106.976 116.554 107.095 119.649C107.241 123.469 109.554 126.516 111.41 128.093C112.053 128.64 112.644 129.011 113.075 129.186C113.285 129.272 113.466 129.313 113.608 129.318C120.647 131.498 126.532 132.624 131.148 133.179C138.519 134.065 142.671 133.496 143.148 133.423C143.534 133.461 146.128 133.637 148.839 131.898C150.215 131.016 151.624 129.639 152.782 127.49C153.761 125.675 155.262 121.425 154.115 117.958C153.493 116.08 152.11 114.421 149.466 113.485C148.587 113.174 148.032 112.77 147.68 112.296C147.225 111.684 147.109 110.965 147.036 110.228C146.926 109.132 146.902 107.999 146.284 107.033C145.789 106.257 144.917 105.574 143.298 105.118C141.985 104.748 141.164 103.632 140.531 102.166C139.752 100.36 139.272 98.028 138.652 95.7656ZM138.157 96.4656C138.844 99.052 139.401 101.668 140.441 103.465C141.099 104.604 141.951 105.424 143.119 105.753C144.524 106.149 145.298 106.715 145.728 107.388C146.288 108.265 146.279 109.3 146.378 110.294C146.464 111.15 146.621 111.978 147.15 112.69C147.565 113.248 148.209 113.741 149.246 114.107C151.653 114.959 152.922 116.456 153.488 118.165C154.574 121.444 153.128 125.46 152.202 127.178C151.108 129.206 149.782 130.51 148.483 131.344C145.767 133.086 143.181 132.764 143.181 132.764C143.149 132.76 143.117 132.76 143.086 132.766C143.086 132.766 137.894 133.629 128.271 132.114C124.203 131.473 119.345 130.408 113.754 128.674C113.717 128.662 113.679 128.658 113.64 128.659C113.521 128.665 113.348 128.598 113.131 128.489C112.77 128.308 112.32 128.003 111.836 127.591C110.084 126.103 107.891 123.23 107.753 119.624C107.639 116.676 108.909 113.25 112.87 109.683C113.857 108.794 114.552 107.62 115.079 106.394C115.975 104.309 116.372 102.076 116.975 100.975C118.101 98.9214 120.054 97.7999 122.32 97.1992C126.575 96.0708 131.922 96.765 135.243 96.8317C136.225 96.8514 137.036 96.8148 137.606 96.6741C137.82 96.6211 138.004 96.551 138.157 96.4656Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M135.859 106.511L124.051 107.611L128.673 125.54L139.605 121.994L135.859 106.511Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.703 114.608C124.703 114.608 132.846 115.13 136.035 108.398C140.117 99.7779 134.54 105.11 134.54 105.11L124.052 106.512L124.703 114.608Z"
          fill="#302323"
          fillOpacity="0.87"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.482 114.624C124.491 114.733 124.578 114.819 124.688 114.826C124.688 114.826 128.116 115.047 131.425 113.38C133.267 112.452 135.071 110.942 136.231 108.49C137.119 106.616 137.554 105.391 137.693 104.625C137.807 103.996 137.715 103.632 137.548 103.451C137.44 103.332 137.297 103.269 137.126 103.259C136.907 103.247 136.629 103.331 136.335 103.481C135.573 103.869 134.665 104.69 134.439 104.9C134.439 104.9 124.021 106.294 124.021 106.294C123.905 106.309 123.822 106.412 123.831 106.528L124.482 114.624ZM124.905 114.394L124.285 106.701L134.567 105.326C134.613 105.32 134.656 105.299 134.69 105.267C134.69 105.267 135.703 104.295 136.534 103.872C136.715 103.78 136.886 103.713 137.032 103.7C137.109 103.692 137.178 103.697 137.224 103.747C137.271 103.799 137.294 103.882 137.303 103.995C137.316 104.138 137.302 104.32 137.261 104.546C137.125 105.291 136.697 106.48 135.835 108.302C134.722 110.652 132.992 112.098 131.227 112.987C128.482 114.37 125.652 114.41 124.905 114.394Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M136.182 106.443C136.143 106.284 135.994 106.177 135.83 106.192L124.023 107.292C123.927 107.301 123.839 107.351 123.783 107.431C123.728 107.51 123.71 107.609 123.734 107.703L128.356 125.632C128.379 125.72 128.437 125.795 128.517 125.838C128.596 125.882 128.69 125.891 128.777 125.863L139.708 122.316C139.872 122.263 139.967 122.093 139.927 121.926L136.182 106.443ZM135.607 106.876L139.215 121.784L128.907 125.128L124.47 107.913L135.607 106.876Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.379 70.3574L103.517 70.9629L104.295 78.1191H109.298L111.224 80.2659L108.011 84.4495L101.535 80.376L97.6343 78.7273L100.379 70.3574Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.716 103.413C106.253 89.3846 110.437 84.7027 111.329 83.5319C114.384 79.5209 117.508 76.4958 113.069 77.6549C112.168 77.8893 106.283 79.879 107.056 81.3823C107.836 82.9062 109.515 79.6567 111.146 76.0857C112.059 74.0849 112.487 73.3185 113.294 71.8088C114.604 69.3606 113.897 68.3118 111.642 69.438C109.304 70.6057 105.532 73.3878 104.571 76.3812C104.735 73.9274 107.701 70.0242 108.655 68.6181C110.353 66.114 109.825 65.2806 108.745 65.3128C106.405 65.3886 101.527 69.9509 100.204 73.2185C99.1275 75.8793 99.83 77.2932 100.863 77.0578C102.604 76.6576 101.803 69.74 101.617 68.5255C101.418 67.2338 100.366 67.3398 99.2233 69.5595C96.6008 74.6539 94.478 80.8066 93.1835 90.4941C92.7068 94.0599 92.4202 99.6028 92.7699 104.08"
          fill="white"
        />
        <path
          d="M107.716 103.413C106.253 89.3846 110.437 84.7027 111.329 83.5319C114.384 79.5209 117.508 76.4958 113.069 77.6549C112.168 77.8893 106.283 79.879 107.056 81.3823C107.836 82.9062 109.515 79.6567 111.146 76.0857C112.059 74.0849 112.487 73.3185 113.294 71.8088C114.604 69.3606 113.897 68.3118 111.642 69.438C109.304 70.6057 105.532 73.3878 104.571 76.3812C104.735 73.9274 107.701 70.0242 108.655 68.6181C110.353 66.114 109.825 65.2806 108.745 65.3128C106.405 65.3886 101.527 69.9509 100.204 73.2185C99.1275 75.8793 99.83 77.2932 100.863 77.0578C102.604 76.6576 101.803 69.74 101.617 68.5255C101.418 67.2338 100.366 67.3398 99.2233 69.5595C96.6008 74.6539 94.478 80.8066 93.1835 90.4941C92.7068 94.0599 92.4202 99.6028 92.7699 104.08"
          stroke="black"
          strokeWidth="0.637846"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.973 102.218C136.551 107.573 131.668 111.525 125.87 111.525C118.96 111.525 113.349 105.911 113.349 99.0015C113.349 92.0924 118.96 86.4783 125.87 86.4783C131.668 86.4783 136.551 90.4298 137.973 95.7849C138.527 95.4536 139.173 95.2669 139.862 95.2669C141.923 95.2669 143.595 96.9414 143.595 99.0015C143.595 101.062 141.923 102.736 139.862 102.736C139.173 102.736 138.527 102.55 137.973 102.218Z"
          fill="white"
        />
        <mask
          id="mask0_597_42317"
          maskUnits="userSpaceOnUse"
          x="113"
          y="86"
          width="31"
          height="26"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M137.972 102.217C136.551 107.573 131.668 111.524 125.869 111.524C118.959 111.524 113.349 105.91 113.349 99.0008C113.349 92.0916 118.959 86.4775 125.869 86.4775C131.668 86.4775 136.551 90.4291 137.972 95.7841C138.527 95.4528 139.173 95.2661 139.862 95.2661C141.923 95.2661 143.595 96.9407 143.595 99.0008C143.595 101.061 141.923 102.735 139.862 102.735C139.173 102.735 138.527 102.549 137.972 102.217Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_597_42317)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M112.782 94.2333L127.597 94.1872L129.974 91.8979L132.181 97.3973L138.342 97.2925C138.08 94.0634 135.839 88.1441 134.026 82.9078L115.278 84.5895L112.782 94.2333Z"
            fill="black"
            stroke="black"
            strokeWidth="0.361421"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.973 102.218C136.551 107.573 131.668 111.525 125.87 111.525C118.96 111.525 113.349 105.911 113.349 99.0015C113.349 92.0924 118.96 86.4783 125.87 86.4783C131.668 86.4783 136.551 90.4298 137.973 95.7849C138.527 95.4536 139.173 95.2669 139.862 95.2669C141.923 95.2669 143.595 96.9414 143.595 99.0015C143.595 101.062 141.923 102.736 139.862 102.736C139.173 102.736 138.527 102.55 137.973 102.218Z"
          stroke="black"
          strokeWidth="0.660798"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.404 96.6886L109.304 95.8069L115.566 102.633"
          fill="white"
        />
        <path
          d="M117.404 96.6886L109.304 95.8069L115.566 102.633"
          stroke="black"
          strokeWidth="0.649128"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M140.721 97.2979L138.275 99.5627L141.324 100.719"
          stroke="black"
          strokeWidth="0.660798"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M124.027 110.51C124.027 110.51 123.654 111.663 122.206 108.273C122.206 108.273 127.582 104.293 131.57 105.16C135.559 106.018 129.012 109.296 128.709 109.643C128.405 109.99 124.027 110.51 124.027 110.51Z"
          fill="#F3AFBA"
          stroke="black"
          strokeWidth="0.660743"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M134.028 100.364L121.021 106.26C125.764 109.659 132.71 107.656 134.028 100.364Z"
          stroke="black"
          strokeWidth="0.660743"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M123.053 97.9334C123.053 97.9334 125.617 95.7046 128.473 98.2346"
          stroke="black"
          strokeWidth="0.660798"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.717 103.411C108.8 111.122 112.469 115.521 116.193 118.028C120.792 121.126 125.475 121.344 125.475 121.344L139.095 120.403L145.525 140.545H129.786C129.786 140.545 106.451 141.992 95.103 123.572C89.3504 114.069 89.1328 103.478 89.1328 103.478L107.717 103.411Z"
          fill="#FADE2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.3969 81.3868C97.9848 82.0528 98.3817 82.6027 98.6625 83.2032C98.946 83.8086 99.1116 84.4649 99.2454 85.3388C99.2663 85.4756 99.3709 85.5848 99.5063 85.612C99.6423 85.6392 99.7804 85.5787 99.8526 85.4605C99.8526 85.4605 100.483 84.4345 101.79 83.7015C102.456 83.328 103.297 83.0316 104.321 82.9846C104.503 82.9761 104.644 82.8214 104.635 82.6393C104.627 82.4572 104.472 82.3162 104.29 82.3247C103.148 82.3782 102.21 82.7107 101.468 83.1276C100.688 83.565 100.124 84.0966 99.7656 84.5002C99.6401 83.9005 99.4821 83.398 99.2603 82.9236C98.9553 82.272 98.5298 81.6725 97.8923 80.9499C97.7718 80.8132 97.5626 80.8001 97.4261 80.9206C97.2896 81.0412 97.2764 81.2501 97.3969 81.3868Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57.184 72.4077L60.096 72.9273L62.4862 75.0673L64.8301 90.2671L52.9399 91.4231L50.8481 86.3588L53.6572 82.7231L57.184 72.4077Z"
          fill="#B29191"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.1802 103.42C52.1837 94.7243 49.9506 89.2202 48.9085 81.6207C48.486 78.5477 53.7279 81.1956 54.7012 84.7361C55.2405 86.6955 55.1802 89.6367 54.0781 89.93C53.2816 90.1425 53.3798 86.9548 53.6259 83.2698C53.7597 81.2679 53.7818 79.0705 53.8499 77.2386C54.2009 67.7732 58.2621 68.755 57.8549 79.725C57.8362 80.2308 57.5697 81.1361 57.1128 80.8769C55.8177 80.1415 56.5683 74.8457 57.2144 72.2955C58.9991 65.2443 63.39 71.3859 62.7015 80.7408C62.486 83.6735 61.9288 84.4981 61.3941 83.8861C59.7582 82.0159 62.9557 69.8303 65.4264 73.8639C68.0305 78.1142 69.2954 97.4531 66.4299 106.702"
          fill="#B29191"
        />
        <path
          d="M51.1802 103.42C52.1837 94.7243 49.9506 89.2202 48.9085 81.6207C48.486 78.5477 53.7279 81.1956 54.7012 84.7361C55.2405 86.6955 55.1802 89.6367 54.0781 89.93C53.2816 90.1425 53.3798 86.9548 53.6259 83.2698C53.7597 81.2679 53.7818 79.0705 53.8499 77.2386C54.2009 67.7732 58.2621 68.755 57.8549 79.725C57.8362 80.2308 57.5697 81.1361 57.1128 80.8769C55.8177 80.1415 56.5683 74.8457 57.2144 72.2955C58.9991 65.2443 63.39 71.3859 62.7015 80.7408C62.486 83.6735 61.9288 84.4981 61.3941 83.8861C59.7582 82.0159 62.9557 69.8303 65.4264 73.8639C68.0305 78.1142 69.2954 97.4531 66.4299 106.702"
          stroke="black"
          strokeWidth="0.660496"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.328 108.677L17.6758 127.033L31.4221 122L35.1031 109.67L23.328 108.677Z"
          fill="#B29191"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7197 113.899C24.7286 115.384 30.5338 115.471 34.1515 112.858L34.784 110.739L22.8482 110.234L21.7197 113.899Z"
          fill="#4B3F3F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.5081 113.837C21.4767 113.94 21.5246 114.051 21.6215 114.099C23.2333 114.895 25.6339 115.3 28.0835 115.114C30.2892 114.946 32.534 114.299 34.2795 113.038C34.3186 113.01 34.3472 112.969 34.361 112.923L34.9935 110.805C35.0128 110.74 35.0012 110.669 34.9616 110.614C34.9225 110.559 34.8597 110.525 34.792 110.522L22.8567 110.017C22.7571 110.013 22.6674 110.076 22.6382 110.172L21.5081 113.837ZM21.9854 113.785L23.007 110.462L34.492 110.949L33.9619 112.725C32.2885 113.911 30.1499 114.516 28.0499 114.675C25.7715 114.848 23.536 114.498 21.9854 113.785Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3604 108.339C23.2057 108.326 23.0626 108.423 23.0169 108.571L17.3652 126.928C17.3283 127.047 17.3625 127.178 17.4533 127.264C17.5441 127.35 17.6762 127.378 17.794 127.334L31.5403 122.301C31.6378 122.265 31.7126 122.186 31.7424 122.086L35.4233 109.755C35.4514 109.661 35.4355 109.558 35.3799 109.476C35.3237 109.394 35.2345 109.342 35.1355 109.334L23.3604 108.339ZM23.5701 109.02L34.6769 109.955L31.1589 121.739L18.1909 126.486L23.5701 109.02Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5395 99.91C17.7069 93.4268 23.0239 88.208 29.5481 88.208C36.1785 88.208 41.5607 93.595 41.5607 100.226C41.5607 106.85 36.1785 112.237 29.5481 112.237C24.8942 112.237 20.8543 109.581 18.8603 105.707C18.1945 106.447 17.2328 106.911 16.1628 106.911C14.1567 106.911 12.5278 105.277 12.5278 103.273C12.5278 101.268 14.1567 99.6342 16.1628 99.6342C16.6497 99.6342 17.1144 99.7351 17.5395 99.91Z"
          fill="#B29191"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.1332 103.125L23.18 99.1099L25.1229 93.6786L25.638 97.7164L37.7198 88.754C37.7198 88.754 30.7326 86.2907 30.0008 85.9996C29.269 85.7084 19.0001 96.4999 19.0001 96.4999L17.1767 98.1171C16.9936 99.2404 17.6841 102.203 18.1332 103.125Z"
          fill="black"
          stroke="black"
          strokeWidth="0.440504"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5395 99.91C17.7069 93.4268 23.0239 88.208 29.5481 88.208C36.1785 88.208 41.5607 93.595 41.5607 100.226C41.5607 106.85 36.1785 112.237 29.5481 112.237C24.8942 112.237 20.8543 109.581 18.8603 105.707C18.1945 106.447 17.2328 106.911 16.1628 106.911C14.1567 106.911 12.5278 105.277 12.5278 103.273C12.5278 101.268 14.1567 99.6342 16.1628 99.6342C16.6497 99.6342 17.1144 99.7351 17.5395 99.91Z"
          stroke="black"
          strokeWidth="0.66042"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.269 93.0931L40.1307 89.2058L38.3122 98.1572"
          fill="#B29191"
        />
        <path
          d="M35.269 93.0931L40.1307 89.2058L38.3122 98.1572"
          stroke="black"
          strokeWidth="0.66042"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.4344 101.268C25.2831 101.16 25.7646 97.5355 29.5536 98.7528"
          stroke="black"
          strokeWidth="0.66042"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.9922 105.456C24.9728 107.904 34.2442 111.173 38.2101 101.872"
          stroke="black"
          strokeWidth="0.66042"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4964 102.756L16.2866 103.574L15.6293 104.516C15.5247 104.665 15.5616 104.871 15.7113 104.976C15.8605 105.08 16.0669 105.043 16.171 104.894L17.0528 103.627C17.1084 103.547 17.126 103.446 17.1002 103.352C17.0748 103.258 17.0088 103.18 16.9196 103.139L14.7717 102.155C14.606 102.079 14.4095 102.152 14.3335 102.318C14.2581 102.484 14.3307 102.68 14.4964 102.756Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M25.6435 87.4899L25.6292 87.4929C24.5734 87.7173 23.5517 88.0926 22.6016 88.6053C21.6372 89.126 20.7476 89.7875 19.983 90.5737C19.2564 91.3216 18.6459 92.1816 18.1885 93.1195C17.8015 93.9131 17.5252 94.7588 17.36 95.6259C17.1982 96.4762 17.1426 97.3449 17.1756 98.2094C17.1971 98.7583 17.2543 99.3051 17.3408 99.8475L32.9658 88.4549C32.9658 88.4549 35.4209 82.1941 33.0743 79.5455C30.8019 76.9811 27.8134 82.2252 25.6435 87.4899Z"
          fill="#69BAC9"
          stroke="black"
          strokeWidth="0.660564"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.7174 96.2767C22.7174 96.2767 23.7688 93.3118 24.9155 90.3086C25.4505 88.9075 26.0065 87.498 26.4848 86.3782C26.5559 86.2105 26.4782 86.0163 26.3104 85.9448C26.143 85.8732 25.9487 85.9512 25.8771 86.1188C25.3966 87.2457 24.8384 88.6641 24.3 90.0738C23.1512 93.0844 22.0949 96.0556 22.0949 96.0556C22.0338 96.2274 22.1235 96.4164 22.2958 96.4774C22.4675 96.5384 22.6563 96.4484 22.7174 96.2767Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.1757 103.412C48.7552 120.644 33.4176 121.344 33.4176 121.344L19.7985 120.403L13.3681 140.545H29.1069C29.1069 140.545 52.4425 141.992 63.7901 123.572C69.5427 114.069 69.7603 103.478 69.7603 103.478L51.1757 103.412Z"
          fill="#E0374F"
        />
        <mask
          id="mask1_597_42317"
          maskUnits="userSpaceOnUse"
          x="13"
          y="103"
          width="57"
          height="38"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M51.1757 103.412C48.7552 120.644 33.4176 121.345 33.4176 121.345L19.7985 120.403L13.3681 140.545H29.1069C29.1069 140.545 52.4425 141.993 63.7901 123.573C69.5427 114.069 69.7603 103.478 69.7603 103.478L51.1757 103.412Z"
            fill="#E0374F"
          />
        </mask>
        <g mask="url(#mask1_597_42317)">
          <path
            d="M28.6009 144.565C25.4991 144.565 22.9846 142.05 22.9846 138.948C22.9846 135.846 25.4991 133.332 28.6009 133.332C31.7028 133.332 34.2173 135.846 34.2173 138.948C34.2173 142.05 31.7028 144.565 28.6009 144.565Z"
            fill="#E9A5B0"
            stroke="black"
            strokeWidth="0.440458"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.9818 128.598C15.88 128.598 13.3654 126.083 13.3654 122.981C13.3654 119.88 15.88 117.365 18.9818 117.365C22.0836 117.365 24.5981 119.88 24.5981 122.981C24.5981 126.083 22.0836 128.598 18.9818 128.598Z"
            fill="#E9A5B0"
            stroke="black"
            strokeWidth="0.440458"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.9681 128.598C33.8663 128.598 31.3517 126.083 31.3517 122.981C31.3517 119.88 33.8663 117.365 36.9681 117.365C40.07 117.365 42.5845 119.88 42.5845 122.981C42.5845 126.083 40.07 128.598 36.9681 128.598Z"
            fill="#E9A5B0"
            stroke="black"
            strokeWidth="0.440458"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.8353 139.841C47.7335 139.841 45.2189 137.326 45.2189 134.225C45.2189 131.123 47.7335 128.608 50.8353 128.608C53.9371 128.608 56.4517 131.123 56.4517 134.225C56.4517 137.326 53.9371 139.841 50.8353 139.841Z"
            fill="#E9A5B0"
            stroke="black"
            strokeWidth="0.440458"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M66.1752 110.58C63.0733 110.58 60.5588 108.066 60.5588 104.964C60.5588 101.862 63.0733 99.3474 66.1752 99.3474C69.277 99.3474 71.7915 101.862 71.7915 104.964C71.7915 108.066 69.277 110.58 66.1752 110.58Z"
            fill="#E9A5B0"
            stroke="black"
            strokeWidth="0.440458"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M54.9505 122.976C51.8487 122.976 49.3342 120.461 49.3342 117.359C49.3342 114.257 51.8487 111.743 54.9505 111.743C58.0524 111.743 60.5669 114.257 60.5669 117.359C60.5669 120.461 58.0524 122.976 54.9505 122.976Z"
            fill="#E9A5B0"
            stroke="black"
            strokeWidth="0.440458"
            strokeMiterlimit="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.1757 103.412C48.7552 120.644 33.4176 121.344 33.4176 121.344L19.7985 120.403L13.3681 140.545H29.1069C29.1069 140.545 52.4425 141.992 63.7901 123.572C69.5427 114.069 69.7603 103.478 69.7603 103.478L51.1757 103.412Z"
          stroke="black"
          strokeWidth="0.660355"
          strokeMiterlimit="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.7715 44.3579C38.7497 44.4101 38.7373 44.4673 38.7373 44.5274C38.7566 44.5551 38.7367 44.5744 38.7441 44.5906C38.7584 44.6208 38.7559 44.6498 38.7628 44.6697C38.7957 44.7697 38.8504 44.8277 38.8932 44.8645C39.0019 44.9573 39.1212 44.9844 39.2467 44.9648C39.3193 44.9533 39.4094 44.9236 39.4945 44.8359C39.51 44.8198 39.574 44.761 39.6076 44.6271C39.6138 44.6018 39.6262 44.5415 39.643 44.449C39.6877 44.1988 39.7753 43.669 39.8914 42.9445C40.4877 39.2316 41.8474 30.3845 42.1375 27.925C42.1655 27.6836 41.9928 27.4646 41.7512 27.4362C41.5101 27.4078 41.2909 27.5807 41.2623 27.8221C40.9741 30.2757 39.6194 39.1016 39.0255 42.8057C38.9106 43.5226 38.8261 44.0471 38.7802 44.2945C38.7764 44.3167 38.7733 44.3378 38.7715 44.3579Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M49.8971 19.236C49.4257 21.6082 48.7008 25.9384 47.9653 30.506C46.6634 38.5971 45.3298 47.4343 45.3298 47.4343C45.2931 47.6746 45.459 47.8992 45.6994 47.9355C45.9397 47.9717 46.164 47.806 46.2006 47.5657C46.2006 47.5657 47.5312 38.7326 48.8331 30.6457C49.5667 26.0909 50.2903 21.7731 50.7605 19.4076C50.8084 19.1692 50.6531 18.9372 50.4146 18.8899C50.176 18.8425 49.9443 18.9976 49.8971 19.236Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.2451 37.1252C34.2451 37.1252 38.1503 36.2764 41.012 35.6401C42.4556 35.3191 43.6352 35.0516 43.9259 34.9724C46.1036 34.3783 47.8273 33.9717 49.6424 33.4493C50.5735 33.1813 51.5282 32.883 52.5798 32.514C52.2568 33.5754 51.722 35.4459 51.445 37.0498C51.2673 38.0734 51.2021 38.9951 51.3307 39.5654C51.6673 41.058 52.396 41.4515 53.173 41.3634C53.7849 41.294 54.5023 40.8468 55.1887 40.2686C56.0881 39.5113 56.9465 38.5381 57.4391 38.2078C57.6404 38.0723 57.6944 37.7984 57.559 37.5967C57.423 37.395 57.1497 37.3413 56.9478 37.4768C56.2571 37.9412 54.8489 39.6687 53.6184 40.305C53.3289 40.4547 53.0594 40.55 52.8214 40.4724C52.5189 40.3737 52.3326 40.0193 52.1866 39.3723C52.0438 38.7402 52.209 37.6176 52.455 36.4421C52.909 34.2735 53.6805 31.9387 53.6805 31.9387C53.7339 31.7786 53.6905 31.6023 53.5687 31.4852C53.4476 31.368 53.2699 31.3306 53.1122 31.389C51.7419 31.8943 50.5517 32.2732 49.3989 32.6049C47.5876 33.126 45.8676 33.5313 43.6942 34.1239C43.4078 34.2019 42.2444 34.4649 40.8213 34.7812C37.9609 35.4167 34.0582 36.2646 34.0582 36.2646C33.8209 36.3162 33.67 36.5509 33.7215 36.7884C33.7731 37.026 34.0079 37.1768 34.2451 37.1252Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.4642 30.4973C58.7151 30.9545 57.907 31.8229 57.3722 32.8781C56.8883 33.833 56.6299 34.937 56.815 36.0185C57.0523 37.4013 57.6684 38.0087 58.3058 38.2087C59.2145 38.4939 60.291 37.9254 60.8146 37.2596C61.3823 36.5384 61.8718 35.6976 62.27 34.8985C62.7874 33.858 63.1483 32.8898 63.3234 32.3601C63.6974 31.2283 63.3483 30.4764 62.7017 30.0976C61.9681 29.6676 60.7003 29.7444 59.4642 30.4973ZM59.9232 31.2492C60.6512 30.804 61.3861 30.6256 61.9358 30.7364C62.1669 30.783 62.3594 30.882 62.4743 31.0519C62.6364 31.2906 62.6383 31.6374 62.4905 32.0847C62.3234 32.5903 61.978 33.5143 61.4836 34.5074C61.1115 35.2547 60.655 36.0421 60.1245 36.7164C59.7953 37.1352 59.1406 37.5495 58.5685 37.37C58.1498 37.2384 57.838 36.7796 57.6821 35.87C57.5293 34.9757 57.7573 34.0655 58.1573 33.2759C58.6107 32.3811 59.2872 31.6368 59.9232 31.2492Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.1401 29.9414C67.0538 30.1128 66.8743 30.4336 66.6277 30.8604C65.8289 32.2431 64.3381 34.7114 62.9728 36.8352C63.0772 35.8103 63.1784 34.8868 63.2909 34.1342L63.7797 31.3639C63.8101 31.1521 63.9549 30.5152 64.022 30.2486C64.0263 30.233 64.0294 30.218 64.0313 30.2036C64.0605 30.1409 64.0754 30.0705 64.0716 29.9968C64.0636 29.8248 63.9791 29.7413 63.9418 29.7038C63.8698 29.6323 63.7878 29.5959 63.7033 29.5819C63.6114 29.5666 63.5064 29.5745 63.3958 29.6439C63.371 29.6598 63.2679 29.7166 63.2107 29.8812C63.2026 29.9044 63.1871 29.9577 63.1685 30.0324C63.0952 30.3208 62.9411 31.0103 62.9082 31.2393L62.4206 34.0037C62.2473 35.1576 62.1032 36.715 61.9293 38.4243C61.374 39.2493 60.8863 39.9295 60.5416 40.3358C59.4546 41.616 58.5148 43.0744 57.7681 44.4468C56.6911 46.4249 56.0171 48.2278 55.8625 49.0713C55.5084 51.0026 56.5407 52.123 57.7942 51.9926C58.6266 51.906 59.6639 51.2166 60.4981 49.6272C61.1218 48.4395 61.5796 46.8179 61.9268 45.0317C62.32 43.0051 62.5728 40.7632 62.7815 38.7234C64.3555 36.3694 66.3966 33.0127 67.3868 31.2987C67.6725 30.8038 67.8719 30.4427 67.952 30.2769C68.0185 30.1382 68.0309 30.0421 68.0321 30.0096C68.0396 29.7963 67.9241 29.6923 67.8408 29.628C67.7731 29.5756 67.5514 29.4597 67.265 29.6879C67.1942 29.7591 67.1519 29.8486 67.1401 29.9414ZM61.7386 40.2253C61.5392 40.4963 61.3615 40.7258 61.2106 40.9037C60.1633 42.1375 59.2589 43.5438 58.539 44.8664C57.5222 46.735 56.8718 48.4327 56.7265 49.2295C56.5115 50.4024 56.942 51.198 57.7029 51.1187C58.3452 51.0519 59.0763 50.4445 59.7198 49.2187C60.3099 48.094 60.7348 46.5556 61.0634 44.8641C61.3516 43.3786 61.564 41.777 61.7386 40.2253ZM67.7973 30.3805C67.8259 30.3684 67.8588 30.3485 67.888 30.3108C67.8601 30.3385 67.8296 30.3618 67.7973 30.3805Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.373 29.5277C67.2823 29.6574 67.2326 29.721 67.2326 29.721C67.081 29.9113 67.1127 30.1886 67.3028 30.3398C67.3127 30.3478 67.3233 30.3552 67.3338 30.362C67.1612 34.3102 67.1972 37.7438 67.209 37.8785C67.2251 38.0606 67.3195 38.1526 67.3885 38.2036C67.4618 38.2585 67.5456 38.2885 67.64 38.2913C67.7022 38.2933 67.9028 38.2856 68.0606 38.0526C68.127 37.9537 68.255 37.712 68.4252 37.3675C69.1091 35.9869 70.5788 32.8206 71.7776 31.1016C73.4566 28.6949 74.8026 27.3371 75.825 26.8096C76.2679 26.5812 76.6214 26.513 76.8934 26.6551C77.0636 26.744 77.1878 26.9114 77.2847 27.1312C77.4214 27.4415 77.4959 27.8456 77.5177 28.3254C77.6065 30.309 76.7791 33.4734 74.9896 36.877C74.8765 37.0921 74.9592 37.3586 75.1747 37.4717C75.3896 37.5847 75.6561 37.5018 75.7691 37.2867C77.6494 33.7075 78.4879 30.3715 78.3935 28.2859C78.3376 27.0394 77.9239 26.2039 77.2997 25.8778C76.8245 25.6297 76.1952 25.6317 75.4225 26.03C74.3274 26.595 72.8565 28.0216 71.0577 30.5995C70.0514 32.0422 68.8544 34.4845 68.0749 36.0859C68.0817 34.5891 68.1171 32.2787 68.237 29.822C68.4743 29.4625 68.8283 28.8817 69.2395 28.0649C69.6805 27.1866 70.1905 26.0304 70.6906 24.5776C71.5788 21.9978 71.8254 20.147 71.6857 19.1116C71.5739 18.2836 71.185 17.8842 70.7657 17.8097C70.4055 17.7456 69.9104 17.9205 69.3917 18.4839C69.0731 18.8303 68.7848 19.4255 68.5469 20.2116C68.227 21.2691 67.9798 22.6915 67.7916 24.2744C67.5947 25.9284 67.4618 27.7595 67.373 29.5277ZM68.3494 27.8717C68.4668 27.6438 68.5904 27.3941 68.7184 27.1221C69.0787 26.3554 69.4712 25.4147 69.8582 24.2909C70.5073 22.4054 70.8048 20.9384 70.8402 19.924C70.8539 19.5224 70.8272 19.1993 70.7595 18.9578C70.7347 18.8697 70.7055 18.7954 70.6682 18.7368C70.6508 18.7101 70.6371 18.6849 70.6135 18.6762C70.5744 18.6621 70.5328 18.6885 70.4818 18.7137C70.3452 18.7812 70.1992 18.9058 70.039 19.0796C69.7849 19.3554 69.5787 19.8404 69.3892 20.4663C69.0811 21.4844 68.8463 22.8543 68.665 24.3782C68.5326 25.4867 68.4295 26.6758 68.3494 27.8717Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.0283 20.466L106.35 13.8068C106.587 13.7492 106.732 13.5108 106.674 13.2746C106.616 13.0385 106.378 12.8935 106.142 12.9511L78.8202 19.6103C78.5842 19.6678 78.4388 19.9062 78.4966 20.1424C78.5543 20.3785 78.7922 20.5235 79.0283 20.466Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88.471 17.5644L84.8373 42.5116C84.8018 42.7521 84.969 42.9758 85.2093 43.0109C85.4503 43.0459 85.674 42.879 85.7088 42.6385L89.3425 17.6914C89.3773 17.4509 89.2102 17.2272 88.9698 17.1921C88.7294 17.1571 88.5058 17.3239 88.471 17.5644Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.9368 28.4634C82.9368 28.4634 86.793 27.3684 90.341 26.4262C92.3374 25.896 94.2363 25.4144 95.2891 25.2041C95.527 25.1564 95.6823 24.9241 95.6345 24.6858C95.5867 24.4475 95.3544 24.2927 95.1165 24.3404C94.0524 24.5536 92.1337 25.0416 90.1155 25.5776C86.5607 26.522 82.6964 27.616 82.6964 27.616C82.4629 27.6823 82.3269 27.926 82.3933 28.1599C82.4598 28.3937 82.7033 28.5297 82.9368 28.4634Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.443 26.6396C108.191 28.6542 106.827 30.8135 105.813 32.8909L104.375 23.3563C104.331 23.021 104.032 23.6507 103.957 23.8168L103.939 23.8554L103.502 23.3895C103.502 23.3895 103.48 23.4706 103.449 23.552C103.325 23.8756 103.005 24.5456 102.188 25.9051C101.629 26.8365 100.842 28.0833 99.7341 29.7498C98.1098 32.1927 96.6768 33.5826 95.596 34.0769C95.1183 34.2953 94.7407 34.341 94.4947 34.1169C94.3438 33.9797 94.2555 33.7598 94.209 33.4777C94.1487 33.1137 94.1655 32.6595 94.2599 32.1241C94.4866 30.8434 94.7196 29.5899 94.9283 28.4951C95.3283 26.3918 95.6376 24.874 95.6376 24.874C95.6867 24.6359 95.5326 24.4031 95.2941 24.3546C95.0562 24.306 94.8233 24.4599 94.7748 24.698C94.7748 24.698 94.4642 26.2206 94.063 28.3305C93.8543 29.4287 93.6207 30.686 93.3934 31.9706C93.148 33.3549 93.399 34.3105 93.9021 34.7683C94.3636 35.1877 95.0686 35.2861 95.9618 34.8774C97.129 34.3435 98.7123 32.8759 100.466 30.237C101.872 28.1237 102.765 26.6787 103.334 25.6935C103.488 25.4257 103.62 25.1907 103.731 24.9845L105.165 34.4945C105.195 34.6899 105.351 34.8416 105.547 34.8654C105.743 34.8891 105.931 34.7791 106.006 34.5963C106.971 32.2522 108.539 29.7317 109.999 27.3844C110.23 27.6218 110.496 27.8205 110.794 27.9724C111.402 28.2811 112.159 28.4029 113.082 28.239C112.286 30.7653 113.287 32.736 115.035 33.286C115.879 33.5516 116.919 33.4933 118.051 32.9807C119.534 32.3092 121.199 30.8395 122.764 28.2826C122.89 28.0752 122.825 27.804 122.618 27.6772C122.41 27.5505 122.139 27.6159 122.012 27.8233C120.174 30.8327 118.225 32.247 116.622 32.518C115.617 32.6879 114.77 32.385 114.251 31.7366C113.578 30.8969 113.459 29.5333 114.118 27.9584C116.386 27.186 118.05 26.2101 119.17 25.2441C120.111 24.4326 120.676 23.6175 120.914 22.9234C121.106 22.3648 121.095 21.8684 120.928 21.4759C120.689 20.9151 120.263 20.5218 119.702 20.4008C119.147 20.2809 118.421 20.433 117.583 21.0846C116.445 21.9703 115.026 23.8427 113.475 27.2443C112.524 27.5265 111.772 27.4844 111.192 27.1898C110.913 27.048 110.678 26.8501 110.48 26.6097C111.621 24.7693 112.642 23.0639 113.185 21.6708C113.905 19.8204 113.774 18.461 112.447 17.846C112.42 17.8334 112.391 17.8235 112.362 17.8167C111.363 17.5843 110.456 18.1564 109.802 19.2275C108.851 20.7868 108.434 23.4169 108.956 25.4159C109.072 25.86 109.233 26.2729 109.443 26.6396ZM114.635 26.8366C116.369 26.1649 117.679 25.3718 118.597 24.5796C119.389 23.896 119.884 23.2231 120.085 22.6383C120.193 22.3222 120.216 22.0422 120.12 21.8202C119.762 20.9787 118.792 20.9433 117.398 22.4536C116.572 23.3482 115.641 24.7549 114.635 26.8366ZM109.989 25.7575C110.995 24.122 111.877 22.6097 112.366 21.352C112.606 20.7349 112.75 20.1869 112.746 19.7232C112.741 19.2483 112.557 18.8824 112.119 18.6628C111.489 18.5423 110.968 19.0035 110.552 19.6849C109.706 21.0729 109.342 23.4148 109.806 25.1942C109.856 25.3896 109.917 25.5782 109.989 25.7575Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.171 46.7104L23.0489 49.6642C22.8243 49.7573 22.718 50.0154 22.8111 50.2398C22.9041 50.4643 23.162 50.571 23.3866 50.4779L30.5087 47.5241C30.7328 47.4308 30.8396 47.173 30.7466 46.9485C30.6536 46.724 30.3957 46.6174 30.171 46.7104Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.114 49.7947L22.988 61.3078C22.8373 61.4984 22.8691 61.7755 23.0597 61.9265C23.2502 62.0775 23.5271 62.0453 23.6784 61.855L32.8044 50.3419C32.9551 50.1513 32.9233 49.8742 32.7328 49.7232C32.5423 49.5721 32.2653 49.6043 32.114 49.7947Z"
          fill="#231F20"
        />
        <path
          d="M54.1512 27.6092C54.6486 27.6092 55.0518 27.206 55.0518 26.7085C55.0518 26.2111 54.6486 25.8079 54.1512 25.8079C53.6537 25.8079 53.2505 26.2111 53.2505 26.7085C53.2505 27.206 53.6537 27.6092 54.1512 27.6092Z"
          fill="#231F20"
        />
        <path
          d="M95.6575 20.9034C96.1549 20.9034 96.5582 20.5002 96.5582 20.0027C96.5582 19.5053 96.1549 19.1021 95.6575 19.1021C95.1601 19.1021 94.7568 19.5053 94.7568 20.0027C94.7568 20.5002 95.1601 20.9034 95.6575 20.9034Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M37.7697 49.9921L36.343 57.6808C36.2984 57.9198 36.4565 58.1498 36.6955 58.1938C36.9344 58.2384 37.1645 58.0803 37.2085 57.8413L38.6352 50.1532C38.6797 49.9137 38.5216 49.6836 38.2827 49.6396C38.0437 49.595 37.8137 49.7532 37.7697 49.9921Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M131.209 0.47958L122.734 13.9807C122.605 14.1865 122.667 14.4585 122.873 14.5878C123.079 14.7173 123.351 14.6548 123.48 14.4489L131.955 0.947852C132.084 0.742002 132.022 0.470041 131.816 0.34072C131.61 0.211706 131.338 0.273729 131.209 0.47958Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M127.839 17.3853L135.69 14.0201C135.913 13.9243 136.017 13.665 135.921 13.4415C135.825 13.2181 135.566 13.1145 135.342 13.2102L127.492 16.5754C127.268 16.6711 127.165 16.9305 127.26 17.1539C127.356 17.3774 127.616 17.481 127.839 17.3853Z"
          fill="#231F20"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.253 3.45849L119.848 10.8656C119.834 11.1082 120.021 11.3158 120.263 11.3291C120.506 11.3424 120.714 11.1564 120.727 10.9138L121.132 3.50665C121.146 3.26406 120.959 3.05621 120.716 3.04291C120.474 3.02961 120.266 3.2159 120.253 3.45849Z"
          fill="#231F20"
        />
      </g>
      <defs>
        <clipPath id="clip0_597_42317">
          <rect
            width="158.534"
            height="144.839"
            fill="white"
            transform="translate(0.233398)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
